import React from 'react';
import {
  getDayOfWeekInitialLabel,
  getDayOfWeekShortLabel,
  WorkingDayBadge,
} from '@core/job/workingDays/workingDays.util';

interface WorkingDaysDisplayProps {
  /**
   * Every day to show, including unselected ones. Selection only changes
   * styling — never pass a selected-only list here.
   */
  badges: WorkingDayBadge[];
}

/**
 * Read-only working-day badges for job cards (drawer, lists).
 * Selected days are filled; unselected days in the set stay muted but visible.
 */
const WorkingDaysDisplay: React.FC<WorkingDaysDisplayProps> = ({ badges }) => {
  if (badges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1" aria-label="Working days">
      {badges.map(({ day, isSelected }) => (
        <span
          key={day}
          title={getDayOfWeekShortLabel(day)}
          aria-label={`${getDayOfWeekShortLabel(day)}${isSelected ? ', working day' : ', not a working day'}`}
          className={`inline-flex h-6 w-6 items-center justify-center rounded text-xs font-medium ${
            isSelected
              ? 'bg-gray-700 text-white'
              : 'border border-gray-300 bg-gray-100 text-gray-500'
          }`}
        >
          {getDayOfWeekInitialLabel(day)}
        </span>
      ))}
    </div>
  );
};

export default WorkingDaysDisplay;
